import { render } from "./CriticalActions.vue?vue&type=template&id=20641cf1"
import script from "./CriticalActions.vue?vue&type=script&lang=js"
export * from "./CriticalActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__